/** Generic coercion helpers for mapping raw `unknown` API responses into typed shapes.
 *  Shared across mappers — keep this file dependency-free. */

/** The value if it's an array, otherwise an empty array. */
export const asArray = (value: unknown): unknown[] => (Array.isArray(value) ? value : []);

/** Narrows a list to its non-null, object-shaped (record) entries. */
export const asRecords = (rows: unknown[]): Record<string, unknown>[] =>
  rows.filter((r): r is Record<string, unknown> => typeof r === 'object' && r !== null);

/** Coerces to a number; null/undefined/'' → null. */
export const toNumberOrNull = (value: unknown): number | null =>
  value === null || value === undefined || value === '' ? null : Number(value);

/** Coerces to a string; null/undefined → null. */
export const toStringOrNull = (value: unknown): string | null =>
  value === null || value === undefined ? null : String(value);
